import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

export async function getPayoutPlanByRequestId(
  dispatch: Dispatch,
  requestType: string,
  requestId: string,
) {
  const response = await requestHandler({
    method: 'get',
    url: `internal/payoutPlan/${requestType}/${requestId}`,
    dispatch,
  });
  if (response) return response.data;
}
